<template>
  <div>
    <div class="mpd-footer pc" v-if="isPcSize">
      <div class="content">
        <div class="related-course">
          <h4>相关课程</h4>
          <!--
          年度案例研究峰会|经典课程|研发战略能力提升指南|A2M人工智能峰会|MPD AI驱动创新峰会|
          GIAC全球互联网架构大会|HiPM产品创新力峰会

          我感觉留一个课程的，连接到官网课程
          加一个研发战略能力提升指南，链接到这个
          再加一个hipm，https://hipm.msup.com.cn/2026/home?qd=dahui&time=1773902869737
          -->
          <div class="row">
            <a href="http://www.top100summit.com?qd=mpd" target="_blank">年度案例研究峰会</a> |
            <a href="https://www.msup.com.cn/course/index" target="_blank">经典课程</a> |
            <a href="https://www.msup.com.cn/budgets/new-index" target="_blank">研发战略能力提升指南</a> |
          </div>
          <div class="row">
            <a href="http://a2m.msup.com.cn?qd=mpd" target="_blank">A2M人工智能峰会</a> |
            <a href="/" target="_blank">MPD AI驱动创新峰会</a> |
          </div>
          <div class="row">
            <a href="http://giac.msup.com.cn?qd=mpd" target="_blank">GIAC全球互联网架构大会</a> |
            <a href="http://hipm.msup.com.cn?qd=mpd" target="_blank">HiPM产品创新力峰会</a>
          </div>
          <!-- <div class="row">
            <a href="http://www.top100summit.com" target="_blank">年度案例研究峰会</a> |
            <a href="https://www.msup.com.cn/index.php?m=content&amp;c=index&amp;a=courselist" target="_blank">经典公开课</a> |
            <a href="https://www.msup.com.cn/index.php?m=content&amp;c=index&amp;a=courselist" target="_blank">个性化课程</a> |
          </div>
          <div class="row">
            <a href="http://old.msup.com.cn/bayarea" target="_blank">海外研修之旅</a> |
            <a href="http://a2m.msup.com.cn/" target="_blank">人工智能峰会</a> |
            <a href="/" target="_blank">MPD工作坊</a> |
          </div>
          <div class="row">
            <a href="http://giac.msup.com.cn" target="_blank">GIAC全球互联网架构大会</a>
          </div> -->
        </div>
        <div class="contact-us">
          <h4>联系我们</h4>
          <p>峰会咨询：400-8128-020</p>
          <!-- 艳慧 -->
          <p>赞助合作：sissi</p>
          <p>联系电话：130-4321-8801</p>
          <p>邮箱：market@msup.com.cn</p>
          <slot v-if="global.area_id >= '4886'">
            <!-- 明慧 -->
            <!-- <p>票务咨询：Reki </p>
            <p>联系电话：138-2010-5680</p>
            <p>邮箱：reki@msup.com.cn</p> -->
            <!-- 董楠 -->
            <p>票务咨询：董楠 </p>
            <p>联系电话：135-0218-3421</p>
            <p>邮箱：dong.nan@msup.com.cn</p>
          </slot>
          <slot v-else>
            <!-- 东光 -->
            <p>票务咨询：张东光</p>
            <p>联系电话：159-0023-2589</p>
            <p>邮箱：dongguang.zhang@msup.com.cn</p>
          </slot>
        </div>
        <div class="sponsor">
          <h4>主办方</h4>
          <img src="../assets/img/foot_img.png" alt="" />
        </div>
      </div>
      <!-- <div class="content">
        <div class="company col-sm-12 col-xs-12"
        >CopyRight © 2008-{{global.year.toString().slice(0,4)-1}} Msup</div>
      </div> -->
    </div>
    <div class="mpd-footer mob" v-else>
      <div class="content">
        <div class="sponsor">
          <img src="../assets/img/wap_foot_bg.png" alt="" />
          <div class="qrcode-wrapper">
            <div class="qrcode col-sm-4 col-xs-4">
              <img src="../assets/img/wap_foot_02.png" alt="" />
            </div>
            <div class="contact-us col-sm-8 col-xs-8">
              峰会咨询：400-8128-020<br />
              赞助合作：sissi<br />
              联系电话：130-4321-8801<br />
              邮箱：market@msup.com.cn<br />
              <slot v-if="global.area_id >= '4886'">
                <!-- 票务咨询：Reki<br />
                联系电话：138-2010-5680<br />
                邮箱：Reki@msup.com.cn -->
                票务咨询：董楠 <br />
                联系电话：135-0218-3421<br />
                邮箱：dong.nan@msup.com.cn<br />
              </slot>
              <slot v-else>
                票务咨询：张东光<br />
                联系电话：159-0023-2589<br />
                邮箱：dongguang.zhang@msup.com.cn
              </slot>
            </div>
          </div>
        </div>
        <!-- <div class="company col-sm-12 col-xs-12"
        >CopyRight © 2008-{{global.year.toString().slice(0,4)-1}} Msup</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mixinScreen } from '../mixin'

export default {
  mixins: [ mixinScreen ]
}
</script>

<style lang="scss" scoped>
.mpd-footer {
  // margin: 70px auto 30px;
  margin: 0 auto;
  border-top: 1px solid #f5f5f5;
  &.pc {
    // padding: 0 50px;
    // padding: 70px 0 30px 0;
    // padding: 70px 50px 30px 50px;
    // height: 270px;
    height: 340px;
    padding: 0;
    padding-top: 50px;
    // padding-bottom: 60px;
    background-size: cover;
    background-position: center;
    // background-color: var(--main-bgcolor);
    background-color: #fff;
    .company {
      // margin: 0 auto;
      margin: 0;
      padding: 0;
    }
  }
  &.mob {
    padding-bottom: 50px;
  }
  .content {
    max-width: 1200px;
    margin: 0 auto;
    display: -webkit-box;  /* OLD - iOS 6-, Safari 3.1-6 */
    display: -moz-box;     /* OLD - Firefox 19- (buggy but mostly works) */
    display: -ms-flexbox;  /* TWEENER - IE 10 */
    display: -webkit-flex; /* NEW - Chrome */
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    h4 {
      font-size: 22px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      text-align: left;
      // color: #ffffff;
      color: #000000;
      margin-bottom: 20px;
    }
    .related-course {
      text-align: left;
      .row {
        // color: #ffffff;
        color: #000000;
        a {
          text-decoration: none;
          font-family: Source Han Sans CN;
          font-size: 16px;
          font-weight: 400;
          line-height: 25px;
          // color: #ffffff;
          color: #333;
        }
      }
    }
    .contact-us {
      text-align: left;
      // line-height: 36px;
      p {
        margin-bottom: 0;
        text-align: left;
        font-family: Source Han Sans CN;
        font-size: 16px;
        font-weight: 400;
        line-height: 25px;
        // color: #ffffff;
        color: #333;
      }
    }
    .sponsor {
      text-align: left;
      margin-right: 10px;
      h4 {
        margin-bottom: 16px;
      }
      .qrcode-wrapper {
        margin-top: 18px;
        display: -webkit-box;  /* OLD - iOS 6-, Safari 3.1-6 */
        display: -moz-box;     /* OLD - Firefox 19- (buggy but mostly works) */
        display: -ms-flexbox;  /* TWEENER - IE 10 */
        display: -webkit-flex; /* NEW - Chrome */
        display: flex;
        flex-direction: row;
        p {
          margin-left: 19px;
          width: 112px;
          font-size: 14px;
          font-weight: 400;
          font-family: Source Han Sans CN;
          text-align: left;
          color: #000000;
          line-height: 18px;
          display: -webkit-box;  /* OLD - iOS 6-, Safari 3.1-6 */
          display: -moz-box;     /* OLD - Firefox 19- (buggy but mostly works) */
          display: -ms-flexbox;  /* TWEENER - IE 10 */
          display: -webkit-flex; /* NEW - Chrome */
          display: flex;
          flex-direction: column-reverse;
        }
      }
    }
  }
  .company {
    // max-width: 1200px;
    max-width: 1440px;
    font-size: 14px;
    font-family: Source Han Sans CN, Source Han Sans CN-Normal;
    text-align: left;
    color: #999999;
    line-height: 30px;
  }
}
// @media (min-width: 1024px) {
// @media (min-width: 961px) {
//   .mob {
//     display: none;
//   }
//   .pc {
//     display: block;
//   }
// }
// @media (max-width: 1023px) {
// @media (max-width: 960px) {
@media (max-width: 767px) {
  // .pc {
  //   display: none;
  // }
  // .mob {
  //   display: block;
  // }
  .mpd-footer {
    width: 100%;
    // margin-top: 40px;
    // margin-bottom: 30px;
    // background-color: var(--main-bgcolor);
    .content {
      display: -webkit-box;  /* OLD - iOS 6-, Safari 3.1-6 */
      display: -moz-box;     /* OLD - Firefox 19- (buggy but mostly works) */
      display: -ms-flexbox;  /* TWEENER - IE 10 */
      display: -webkit-flex; /* NEW - Chrome */
      display: flex;
      flex-direction: column;
      padding-left: 0;
      padding-right: 0;
      .sponsor {
        margin-right: 0;
        h4 {
          font-size: 16px;
          margin-top: 5px;
          margin-bottom: 10px;
        }
        img {
          width: 100%;
        }
        .qrcode-wrapper {
          margin-top: 0;
          div {
            padding-right: 0;
          }
          .contact-us {
            padding-right: 0;
            // color: #ffffff;
            color: #000000;
            font-size: 14px;
            line-height: 20px;
          }
          .logo {
            max-width: 100%;
          }
        }
      }
      .company {
        margin-top: 0;
        line-height: 25px;
        padding-top: 15px;
        padding-bottom: 20px;
        padding-left: 15px;
        // color: #95cfff;
        font-size: 12px;
        // text-align: right;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/componentsNew/Footer.vue